import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({ providedIn: 'root' })
export class AccesoIpService {

  private readonly base = '/security/ip-access';

  constructor(private api: ApiService) {}

  // `_token` es legacy y se ignora (el token va en el header Bearer).

  listarSucursales(_token?: any): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/list`, {});
  }

  agregarIp(_token: any, COD_SURC: number, direcionIp: string): Observable<{ ips: any[] }> {
    return this.api.post(`${this.base}/add`, { COD_SURC, direcionIp });
  }

  eliminarIp(_token: any, COD_SURC: number, direcionIp: string): Observable<{ ips: any[] }> {
    return this.api.post(`${this.base}/remove`, { COD_SURC, direcionIp });
  }
}
